<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Management Category</h2>
            <ElementCategories category_id="8" elementName="Management"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Management',
                    to:'/managements/all'
                }, {
                    text: 'Management Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
